import React from 'react';
import TextField from 'material-ui/TextField';

class MainSearch extends React.PureComponent {
    render() {
        return (
            <TextField />
        );
    }
}

export default MainSearch;


// WEBPACK FOOTER //
// ./src/components/MainSearch/index.jsx